import type { IconSvgObject } from './types';

const ShoppingBag01Icon: IconSvgObject = [
  ["path", { d: "M21 17.9953C20.7031 10.2055 19.2962 5.84068 18.5398 4.02071C18.2702 3.37198 17.6261 3 16.9235 3L7.07645 3.00002C6.37392 3.00002 5.72977 3.372 5.46016 4.02073C4.70379 5.8407 3.29693 10.2055 2.99999 17.9953C2.93688 19.6509 4.28721 21 5.94407 21L18.0559 21C19.7128 21 21.0631 19.6509 21 17.9953Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 6.98499C9 8.64184 10.3431 9.98499 12 9.98499C13.6569 9.98499 15 8.64184 15 6.98499", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ShoppingBag01Icon;
